<div [ngClass]="isModalOpened ? '' : 'sticky-order-summary'">
  <udex-tile
    tabindex="0"
    libGroupSkip
    [groupSkipContent]="true"
    [interactive]="true"
    [href]="'javascript:void(0)'"
  >
    <ng-container *ngIf="!isLoading; else loadingSpinner">
      <h1 class="heading__regular--xxxs udex-pb-24">
        {{ product.name }}
      </h1>
      <ng-container *ngIf="commercialModelConfig?.showPricePerMonth">
        <div class="prices">
          <!-- Price Per License -->
          <div class="price-per-license udex-pb-32">
            <h3
              *ngIf="ttTranslations$ | async as ttTranslations"
              class="eyebrow--s udex-pb-4 udex-mb-12"
            >
              {{ ttTranslations?.priceHeadingText | uppercase }}
            </h3>
            <div class="price-breakdown udex-mb-4">
              <h6 class="navigation__medium--xs">
                {{ "configurator.per" | cxTranslate }}
                {{ "configurator.month" | cxTranslate }}
              </h6>
              <span class="navigation__medium--xs text-black">
                {{ priceData?.price?.formattedValues?.netPricePerMonth }}
              </span>
            </div>
          </div>
          <!-- Price per Month -->
          <div
            *ngIf="priceData?.price?.priceCalculationBreakdown"
            class="price-per-month"
          >
            <h3 class="eyebrow--s udex-pb-4 udex-mb-12">
              {{ "configurator.orderSummary" | cxTranslate | uppercase }}
            </h3>
            <ng-container
              *ngFor="
                let breakdown of priceData.price.priceCalculationBreakdown;
                let i = index
              "
            >
              <ng-container
                *ngIf="
                  breakdown.startDate &&
                  breakdown.endDate &&
                  breakdown?.formattedValues?.totalValue
                "
              >
                <div class="price-breakdown udex-mb-12">
                  <h6 class="navigation__medium--xs">
                    <span>{{ breakdown.startDate | dcpDate }}</span>
                    <span> - </span>
                    <span>{{ breakdown.endDate | dcpDate }}</span>
                  </h6>
                  <span class="navigation__medium--xs text-black">
                    {{ breakdown?.formattedValues?.totalValue }}
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <!-- Subtotal Derivatives section -->
        <ng-container *ngIf="supplierAlternativeIdCount > 0">
          <dcp-derivative-prices
            [derivativePrice]="derivativePrice"
            [orderEntriesOneParent]="orderEntriesOneParent"
            [subtotalPrice]="subtotalPrice"
            [supplierAlternativeIdCount]="supplierAlternativeIdCount"
            [product]="product"
            [priceData]="priceData"
          ></dcp-derivative-prices>
        </ng-container>
      </ng-container>
      <!-- Total pricing section -->
      <div
        *ngIf="ttTranslations$ | async as ttTranslations"
        class="total-pricing"
      >
        <div class="price-breakdown udex-pt-16">
          <h6 class="body--l">
            {{ "configurator.orderTotal" | cxTranslate }}:
          </h6>
          <span class="heading__medium--xxs text-grey" data-cy="total-price">
            {{ totalPrice }}
          </span>
        </div>
        <!-- Subheadings -->
        <div class="udex-pb-16">
          <p
            class="body--xxs subheading udex-m-0"
            *ngIf="ttTranslations$ | async as ttTranslations"
          >
            {{ ttTranslations?.priceSubheading }}
          </p>
          <p
            class="body--xxs subheading udex-m-0"
            *ngIf="ttTranslations?.priceSubheading2"
          >
            {{ ttTranslations.priceSubheading2 }}
          </p>
        </div>
      </div>
      <!-- CTA Buttons -->
      <div class="cta-buttons udex-mt-24">
        <ng-content></ng-content>
      </div>
    </ng-container>
    <ng-template #loadingSpinner>
      <div class="loading-indicator">
        <dcp-loading-indicator></dcp-loading-indicator>
      </div>
    </ng-template>
  </udex-tile>
</div>
